import { Box, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import globalStyles from "../../../global";

const Banner = ({ countryCode }) => {
  const { t, i18n } = useTranslation();
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  const isRTL = i18n.dir() === "rtl";

   const styles = {
    mainContainer: {
      position: "relative",
      width: "100%",
      minHeight: "300px",
      background: "#F2F3F0",
      display: "flex",
      overflow: "hidden",
      alignItems: "center",
      justifyContent: "center"
    },
    contentWrapper: {
      width: "100%",
      maxWidth: "1200px",
      display: "flex",
      flexDirection: { xs: "column", md: isRTL ? "row-reverse" : "row" },
      alignItems: "end",
      justifyContent: "center",
      mx: "auto",
      // minHeight: { xs: 0, md: 420 },
      gap: {
        xs: 4,
        md: 0,
      },
      height: "100%",
    },
    contentContainer: {
      flex: "0 0 48%",
      width: { xs: "100%", md: "48%" },
      display: "flex",
      flexDirection: "column",
      justifyContent: "end",
      pl: { xs: 2, md: isRTL ? 0 : 4 },
      pr: { xs: 2, md: isRTL ? 4 : 0 },
      py: { xs: 2, md: 6 },
      pt: {
        xs: 6,
        sm: 8,
      },
      zIndex: 2,
      alignItems: isRTL ? "flex-end" : "flex-start",
      textAlign: isRTL ? "right" : "left",
    },
    title: {
      color: globalStyles.colors.head_green,
      fontWeight: 600,
      fontSize: {
        md: "55px",
        sm: "36px",
        xs: "30px",
      },
      mb: 2,
      fontFamily: globalStyles.fonts.primaryUAE,
      textAlign: isRTL ? "right" : "left",
      lineHeight: "auto",
      letterSpacing: "1%",
    },
    title2: {
      color: globalStyles.colors.head_green,
      fontWeight: 600,
      fontSize: {
        md: "55px",
        sm: "36px",
        xs: "30px",
      },
      fontFamily: globalStyles.fonts.primaryUAE,
      textAlign: isRTL ? "right" : "left",
      lineHeight: "auto",
      letterSpacing: "1%",
    },
    brandText: {
      color: "#76B947",
      display: "block",
      marginBottom: 1,
    },
    subtitle: {
      color: globalStyles.colors.uclean_medium_gray,
      fontSize: {
        sm: "18px",
        xs: "14px",
      },
      mb: 4,
      fontFamily: globalStyles.fonts.primary,
      textAlign: isRTL ? "right" : "left",
      lineHeight: "auto",
      letterSpacing: "1%",
    },
    buttonGroup: {
      display: "flex",
      flexDirection: { xs: "column", sm: "row" },
      gap: 2,
      justifyContent: isRTL ? "flex-end" : "flex-start",
      width: "100%",
    },
    imageContainer: {
      flex: "0 0 52%",
      width: { xs: "100%", md: "52%" },
      display: "flex",
      alignItems: "end",
      justifyContent: "center",
      minHeight: { xs: 220, md: 420 },
      zIndex: 1,
      position: "relative",
      overflow: "visible",
      pl: { xs: 0, md: isRTL ? 0 : 2 },
      pr: { xs: 0, md: isRTL ? 2 : 0 },
    },
    bannerImg: {
      width: "82%",
      maxWidth: 600,
      minWidth: 340,
      height: "auto",
      display: "block",
      margin: "0 auto",
      objectFit: "contain",
      marginBottom: "-10px",
    },
  };

  // Helper to get country-specific text, fallback to default
  const getCountryT = (key, fallbackKey) => {
    // Try country-specific key first
    const countryKey = `heroSection.${countryCode}.${key}`;
    const fallback = `heroSection.${fallbackKey}`;
    const translation = t(countryKey, { defaultValue: "" });
    return translation !== "" ? translation : t(fallback);
  };

  // Country-specific titles: expects
  //   heroSection.UAE.titles = []
  //   heroSection.INDIA.titles = []
  // Fallback: heroSection.titles
  const titles =
    t(`heroSection.${countryCode}.titles`, { returnObjects: true, defaultValue: [] }).length > 0
      ? t(`heroSection.${countryCode}.titles`, { returnObjects: true })
      : t(`heroSection.titles`, { returnObjects: true });

  // Phone number
  // const phoneNumber = getCountryT("contact.phoneNumber", "contact.phoneNumber");

  // Subtitle
  const subtitle = getCountryT("subtitlesSr.main", "subtitlesSr.main");

  // ... styles as before


  return (
    <Box sx={styles.mainContainer}>
      <Box sx={styles.contentWrapper}>
        {/* Content */}
        <Box sx={styles.contentContainer}>
          <Typography variant="h1" sx={styles.title}>
            {titles[0]}
            <Box sx={styles.title2}>{titles[1]}</Box>
            <Box component="span" sx={styles.brandText}>
              {titles[2]}
            </Box>
          </Typography>
          <Typography sx={styles.subtitle}>
            {subtitle}
          </Typography>
          <Box sx={styles.buttonGroup}>
            <Button
              sx={{
                borderRadius: "10px",
                backgroundColor: globalStyles.colors.uclean_green,
                color: globalStyles.colors.white || "#ffffff",
                fontSize: {
                  sm: "16px",
                  xs: "12px",
                },
                fontFamily: ' "Poppins", serif ',
                fontWeight: 600,
                px: 4,
                py: 1.5,
                minWidth: {
                  xs: "180px",
                  md: "200px",
                },
                "&:hover": {
                  color: globalStyles.colors.white || "#ffffff",
                  backgroundColor: globalStyles.colors.army_green || "#4caf50",
                },
              }}
               href="https://play.google.com/store/apps/details?id=com.ucleanlaundry&hl=en_IN&pli=1"
               target="_blank"
              rel="noopener noreferrer"
            >
           Download The App
            </Button>
          </Box>
        </Box>
        {/* Banner Image */}
        <Box sx={styles.imageContainer}>
          <img
            src={`${imageBaseUrl}uae_banner_bg.svg`}
            alt="Banner"
            style={{
              ...styles.bannerImg,
              transform: isRTL ? "scaleX(-1)" : "none",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Banner;